import React from 'react';
import {Section} from '../section/Section';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import css from './MobileAppSection.module.scss';

export const MobileAppSection: React.FC<{}> = () => {
  let apple = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6811 11.1566C17.7107 14.3346 20.4691 15.3922 20.4996 15.4057C20.4763 15.4802 20.0589 16.9128 19.0464 18.3925C18.1711 19.6717 17.2627 20.9463 15.8316 20.9727C14.4255 20.9986 13.9734 20.1389 12.3658 20.1389C10.7587 20.1389 10.2563 20.9463 8.92525 20.9986C7.54395 21.0509 6.4921 19.6153 5.60956 18.3407C3.80618 15.7335 2.42803 10.9733 4.27854 7.76014C5.19783 6.16447 6.84068 5.15402 8.62385 5.12811C9.98025 5.10223 11.2605 6.04065 12.0897 6.04065C12.9184 6.04065 14.4742 4.91212 16.1098 5.07786C16.7945 5.10636 18.7165 5.35444 19.9506 7.16093C19.8512 7.22258 17.6573 8.49974 17.6811 11.1566ZM15.0385 3.35296C15.7718 2.46528 16.2654 1.22955 16.1308 0C15.0737 0.0424842 13.7955 0.704394 13.0373 1.59159C12.3578 2.37724 11.7627 3.63472 11.9233 4.83994C13.1015 4.93109 14.3051 4.24121 15.0385 3.35296Z"
        fill="white"
      />
    </svg>
  );

  let android = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6756 11.5413L4.07617 20.5508C4.17273 20.8931 4.34627 21.2087 4.58351 21.4736C4.82075 21.7385 5.11541 21.9456 5.44498 22.0792C5.77454 22.2127 6.13028 22.2692 6.485 22.2442C6.83972 22.2192 7.18403 22.1134 7.49161 21.935L17.1676 16.4241L12.6756 11.5413Z"
        fill="#EA4335"
      />
      <path
        d="M21.3688 10.0099L17.1845 7.61328L12.4746 11.7464L17.2037 16.4114L21.356 14.0405C21.7239 13.8478 22.032 13.5582 22.247 13.203C22.462 12.8477 22.5757 12.4404 22.5757 12.0252C22.5757 11.6099 22.462 11.2026 22.247 10.8473C22.032 10.4921 21.7239 10.2025 21.356 10.0099H21.3688Z"
        fill="#FBBC04"
      />
      <path
        d="M4.07692 3.45447C4.02494 3.64663 3.99907 3.84493 4.00003 4.044V19.9613C4.00055 20.1603 4.02638 20.3584 4.07692 20.5509L12.9712 11.772L4.07692 3.45447Z"
        fill="#4285F4"
      />
      <path
        d="M12.7397 12.0027L17.1868 7.61328L7.52365 2.07681C7.16012 1.8639 6.74665 1.75114 6.32536 1.75C5.81656 1.749 5.32138 1.91439 4.91531 2.22096C4.50924 2.52754 4.21455 2.95849 4.07617 3.44811L12.7397 12.0027Z"
        fill="#34A853"
      />
    </svg>
  );

  return (
    <Section
      title="Setup Pulsoid Mobile App"
      number={2}
      type={'mobile-application-setup'}
    >
      <div>
        <div className={css.header}>
          <div className={css.pulsoid_logo_wrapper}>
            <img
              className={css.pulsoid_logo}
              src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/vrchat-worlds/midi-setup-page/pulsoid-logo-300.png"
              alt="pulsoid logo"
            />
          </div>
          <div>
            <div>Download Pulsoid App · Free</div>
            <div className={css.subtitle}>
              Scan QR-code or get the app on App Store or Google Play.
            </div>
          </div>
          <div style={{flexGrow: 1}}></div>
          <div>
            <ButtonV2 type="secondary" href="https://pulsoid.net/s/ios-app">
              {apple}
            </ButtonV2>
            <ButtonV2 type="secondary" href="https://pulsoid.net/s/android-app">
              {android}
            </ButtonV2>
          </div>
        </div>
        <div className={css.line} />
        <div className={css.qr_code_container}>
          <div className={css.qr_code_wrapper}>
            <img
              className={css.qr_code}
              src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/vrchat-worlds/midi-setup-page/pulsoid-net-mobile.png"
              alt="qr code"
            />
          </div>

          <div>
            <a href="https://pulsoid.net/mobile" className={css.link}>
              Scan with camera on your phone to install Pulsoid app
            </a>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div>Connect your HRM to Pulsoid App</div>
          <div className={css.subtitle}>
            Follow the app instructions to start capturing heart rate data from
            your monitor. If you need help, check the Troubleshooting section or
            ask in the{' '}
            <a href="https://pulsoid.net/s/discord-help" className={css.link}>
              Pulsoid Discord
            </a>{' '}
            server.
          </div>
        </div>
      </div>
    </Section>
  );
};
